import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/faq";
import { jsonLd, breadcrumbJsonLd } from "@/pages/faq.seo";

import { brand } from "@/config/brand";
const SITE_URL = brand.url;
const OG_IMAGE = `${SITE_URL}/__l5e/assets-v1/aabeccab-688e-44b7-96b1-aaf70d6a2a8d/social-share-cover.png`;

export const Route = createFileRoute("/faq")({
  head: () => ({
    meta: [
      { title: "FAQ — Common Questions Answered | Digitally Baffled" },
      {
        name: "description",
        content:
          "Answers to the most common questions about working with Digitally Baffled — pricing, timelines, ownership, SEO, AEO, GEO, PPC, and more. No jargon.",
      },
      { property: "og:site_name", content: "Digitally Baffled" },
      { property: "og:title", content: "FAQ — Digitally Baffled" },
      {
        property: "og:description",
        content:
          "Answers to the most common questions about working with Digitally Baffled — pricing, timelines, ownership, SEO, AEO, GEO, PPC, and more.",
      },
      { property: "og:url", content: `${SITE_URL}/faq` },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:locale", content: "en_GB" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "FAQ — Digitally Baffled" },
      {
        name: "twitter:description",
        content:
          "Common questions about pricing, timelines, ownership, SEO, AEO, GEO, and PPC. Answered in plain English.",
      },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/faq` }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(jsonLd) },
      { type: "application/ld+json", children: JSON.stringify(breadcrumbJsonLd) },
    ],
  }),
  component: Page,
});
